import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { ConsultationService } from "@customTypes/consultation";


export interface UpdateConsultationServiceProps {
  consultationServiceId: string;
  consultationService: Partial<ConsultationService>;
}

export const useUpdateClinicConsultationService = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation<any, any, UpdateConsultationServiceProps>({
    mutationFn: ({
      consultationServiceId,
      consultationService,
    }: UpdateConsultationServiceProps) => {
      const payload: any = {
        name: consultationService.name,
        category: consultationService.category,
        price: consultationService.price,
        status: consultationService.status,
        service_duration: consultationService.service_duration,
        in_30_min: consultationService.in_30_min,
        sessions: consultationService.sessions,
        session_interval_days: consultationService.session_interval_days,
      };

      if (consultationService.partner_id) {
        payload.partner_id = consultationService.partner_id;
      }

      return api.put(`clinic/consultation-services/${consultationServiceId}`, payload);
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "update-consultation-service-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.consultationServices(),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Clinic Consultation Service]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.consultationServices(),
      });

      handleErrors(res, "mutation");
    },
  });
};
